import { observer } from 'mobx-react-lite';
import type { SetStateAction } from 'react';
import { useState } from 'react';

import { AccordionV2 } from '@/components/common/AccordionV2/AccordionV2';
import InputElement from '@/components/common/InputElement/InputElement';
import FilterSection from '@/components/menuV2/FilterSection/FilterSection';
import type {
  FilterRecordModelType,
  MenuSortOptionRecordModelType,
} from '@/models/api';

interface MobileFilterProps {
  search?: boolean;
  sorts: MenuSortOptionRecordModelType[];
  filtersData: FilterRecordModelType['sections'];
  isSortSelected: (sort: string | undefined | null) => boolean;
  setCurrentSelectedFilter: (key: string) => void;
  filters: any;
  setFilter: (key: string, value: string) => void;
  isFiltered: (key: string, value: string) => boolean;
}

const MobileFilter = observer(
  ({
    search,
    sorts,
    filtersData,
    isSortSelected,
    setCurrentSelectedFilter,
    filters,
    setFilter,
    isFiltered,
  }: MobileFilterProps) => {
    const [expandedIndex, setExpandedIndex] = useState(-1);

    const handleAccordionToggle = (index: SetStateAction<number>) => {
      setExpandedIndex(expandedIndex === index ? -1 : index);
    };

    const renderSortAccordion = () => (
      <div className="flex border-b px-4 pb-2">
        <AccordionV2 title={'Sort'} className="w-full">
          {sorts?.map((sort) => (
            <InputElement
              key={sort.id}
              label={sort?.name as string}
              type="radio"
              checked={isSortSelected(sort.value)}
              onChange={() => {
                setCurrentSelectedFilter('sort');
                filters.setSort(sort.value);
              }}
            />
          ))}
        </AccordionV2>
      </div>
    );

    const renderFilterAccordions = (startIndex = 0) =>
      filtersData?.slice(startIndex).map((filter, index) => {
        const actualIndex = startIndex + index;
        const isLast = actualIndex === filtersData.length - 1;
        const isExpanded = expandedIndex === actualIndex;

        return (
          <div
            key={filter.id}
            className={`flex flex-col px-4 pb-2 ${
              !isLast || !isExpanded ? 'border-b' : ''
            }`}
            onClick={() => handleAccordionToggle(actualIndex)}
          >
            <AccordionV2 title={filter.name || ''} className="mb-0 w-full">
              <FilterSection
                search={search}
                filter={filter}
                setFilter={setFilter}
                isFiltered={isFiltered}
                setCurrentSelectedFilter={setCurrentSelectedFilter}
              />
            </AccordionV2>
          </div>
        );
      });

    return (
      <div className="flex flex-col">
        {search ? (
          <>
            {filtersData && filtersData.length > 0 && (
              <div className="flex flex-col px-4 pb-2">
                <AccordionV2
                  title={filtersData[0].name || ''}
                  className="mb-0 w-full"
                  expanded
                  hideArrow={true}
                >
                  <FilterSection
                    search={search}
                    filter={filtersData[0]}
                    setFilter={setFilter}
                    isFiltered={isFiltered}
                    setCurrentSelectedFilter={setCurrentSelectedFilter}
                  />
                </AccordionV2>
              </div>
            )}
            {renderSortAccordion()}
            {renderFilterAccordions(1)}
          </>
        ) : (
          <>
            {renderSortAccordion()}
            {renderFilterAccordions()}
          </>
        )}
      </div>
    );
  },
);

export default MobileFilter;
